<template>
  <div class="role_wrapper">
    <div style="margin-bottom:20px;">
      <el-button
        v-auth="'sys:cross:add'"
        @click="addUser('')"
        type="primary"
        icon="el-icon-plus"
      >{{ $t('user.addUser') }}
      </el-button>
    </div>
    <div style="margin-bottom:20px;">
      <el-form :inline="true" ref="formSearch" :model="formSearch" class="demo-form-inline">
        <el-form-item :label="$t('user.loginName')" prop="userName">
          <el-input v-model="formSearch.userName" :placeholder="$t('user.loginName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="formSearch.status" :placeholder="$t('user.userStatus')">
            <el-option :label="$t('common.start')" value="1"></el-option>
            <el-option :label="$t('common.stop')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-auth="'sys:cross:check'">
          <el-button type="primary" @click="onSubmitSearch">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      v-loading="loading"
      :row-class-name="tableRowClassName"
      :data="userListData"
      style="width: 100%">
      <el-table-column :prop="item.id" :label="item.name" v-for="item in userListNav" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <p type="text" v-if="scope.row.status==0" plain>{{ $t('common.stop') }}</p>
          <p type="text" v-if="scope.row.status==1" plain>{{ $t('common.start') }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope" v-if="scope.row.status==1">
          <el-button
            size="small"
            type="danger"
            v-auth="'sys:cross:delete'"
            @click="deleteData(scope.$index, scope.row)"
          >{{ $t('common.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
    <!-- 新增用户弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showBox" v-if="showBox">
      <el-form ref="formAdd" :rules="rules" :model="form">
        <el-form-item label="被copy的角色选择" :label-width="formLabelWidth" prop="sourceRoleId">
          <el-select v-model="form.sourceRoleId" placeholder="选择被copy的角色">
            <el-option v-for="item in sourceRoleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块" :label-width="formLabelWidth" prop="modelId">
          <el-select v-model="form.modelId" @change="getPermissions" placeholder="选择模块">
            <el-option v-for="item in modelList" :key="item.id" :label="item.modelName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('user.roleChoice')" :label-width="formLabelWidth" prop="roleId">
          <el-select v-model="form.roleId" @change="getRolesId" :placeholder="$t('user.roleChoice')">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户选择" :label-width="formLabelWidth" prop="userId">
          <el-select v-model="form.userId" placeholder="用户选择">
            <el-option v-for="item in usersList" :key="item.id" :label="item.displayName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleSubmit">{{ $t('common.cancle') }}</el-button>
        <el-button type="primary" @click="submitData('formAdd')">{{ $t('common.ok') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { localRead } from '@/utils/tools'
import {
  userListAll,
  delUserList,
  permissionsListAll,
  rolesList,
  save,
  usersList, srcRoles
} from '@/api/sys/crosspermissions'
import { Message } from 'element-ui'
import DateUtil from '@/utils/IM/tradeDataUtil'

export default {
  data() {
    let checkRoles = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error(this.$t('common.rulesText')))
      } else {
        callback()
      }
    }
    let check = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error(this.$t('common.rulesText')))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      userInfo: JSON.parse(localRead(this.$route.query.label + '_sys_userInfo')),
      userListNav:[
        { name: "模块", id: 'modelName' },
        { name: "角色名称", id: 'roleName' },
        { name: "用户名称", id: 'userName' },
        { name: "公司名称", id: 'companyName' },
        { name: "创建时间", id: 'ctime' },
        { name: "操作人", id: 'operateUserName' },
        { name: "操作时间", id: 'operateTime' },
        { name: "操作原因", id: 'operateMsg' },
      ],
      userListData: [],
      titleName: this.$t('common.addNew'),
      formLabelWidth: '150px',
      showBox: false,
      edit: true,
      nameEdit: true,
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      formSearch: {
        userName: '',
        status: ''
      },
      form: {
        sourceRoleId:"",
        modelId: '',
        roleId: '',
        userId: '',
      },
      sourceRoleList:[],
      modelList:[],
      rolesList: [],
      usersList: [],
      rules: {
        sourceRoleId: [
          {
            required: true,
            message: this.$t('common.rulesText'),
            trigger: 'change'
          }
        ],
        modelId: [
          {
            required: true,
            message: this.$t('common.rulesText'),
            trigger: 'change'
          }
        ],
        roleId: [
          {
            required: true,
            message: this.$t('common.rulesText'),
            trigger: 'change',
            type: 'array',
            validator: checkRoles
          }
        ],
        userId: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change",
            type: "array",
            validator: check
          }
        ],
      },
    }
  },
  methods: {
    cancleSubmit() {
      this.showBox = false
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    },
    //要被copy的角色列表
    getSrcRolesList() {
      srcRoles().then(res => {
        this.sourceRoleList = res.result
      })
    },
    //當前用戶下的所有模塊
    getPermissionsList() {
      permissionsListAll().then(res => {
        let data = JSON.parse(JSON.stringify(res.result)), language = localRead('language')
        for (const i in data) {
          data[i].modelName = JSON.parse(data[i].name)[language]
        }
        this.modelList = data
      })
    },
    getPermissions(val) {
      this.form.userId = ""
      this.form.roleId = ""
      this.initRolesId(val)
    },
    /*根據模塊Id獲取角色列表*/
    initRolesId(modelId) {
      rolesList(modelId).then(res => {
        this.rolesList = res.result;
      })
    },
    getRolesId(roleId){
      this.form.userId = ""
      this.getUsersList(roleId)
    },
    /*根據角色獲取用戶列表*/
    getUsersList(roleId) {
      usersList(roleId).then(res => {
        if (res.code == 0) {
          this.usersList = res.result
        }
      })
    },
    getUserListAll() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage
      }
      userListAll(data).then(res => {
        if (res.code == 0) {
          let newData = JSON.parse(JSON.stringify(res.result.list))
          for (const i in newData) {
            newData[i].ctime = DateUtil.formatDate(newData[i].ctime, 'yyyy-MM-dd hh:mm:ss')
            newData[i].operateTime = DateUtil.formatDate(newData[i].operateTime, 'yyyy-MM-dd hh:mm:ss')
          }
          this.userListData = newData
          this.totalSize = res.result.total
          this.loading = false
        }
      })
    },
    resetSearch() {
      this.formSearch = {}
    },
    submitData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          save(this.form).then(res => {
            if (res.code == 0) {
              Message({
                message: this.$t('common.addSu'),
                type: 'success'
              })
            }else {
              this.$message.error(res.message);
            }
            this.getUserListAll()
          })
          this.showBox = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmitSearch() {
      userListAll(this.formSearch).then(res => {
        if (res.code == 0) {
          this.userListData = res.result.list
        }
      })
    },
    addUser(row) {
      this.getSrcRolesList()
      this.getPermissionsList()
      let updateObject
      updateObject = Object.assign({}, row)
      this.showBox = true
      this.form.userId = ""
      this.form.roleId = ""
      for (let key in this.form) {
        this.form[key] = ''
      }
      this.edit = false
    },
    deleteData(node, data) {
      this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
        confirmButtonText: window.$t('im.bt.definite'),
        cancelButtonText: window.$t('im.bt.cancel'),
        type: 'warning',
      }).then(() => {
        delUserList(data.id).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getUserListAll()
          }else {
            this.$message({
              type: 'error',
              message: res.result
            })
          }
        })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getUserListAll()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getUserListAll()
    },
  },
  mounted() {
    this.getUserListAll()
  },
}
</script>
<style lang="scss" scoped>
.role_wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}

.role_wrapper:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
  0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
